import BaseMeetingAttendanceResponse from './BaseMeetingAttendanceResponse'
import {ATTENDANCE_STATUS} from '../../../CodeMaster'

export class MeetingAttendanceNoResponse extends BaseMeetingAttendanceResponse {

    constructor() {
        super(ATTENDANCE_STATUS.UNANSWERED)
    }
}
